import request from '@/utils/request'

// 展示项目下拉
export function apiGetProjectCombobox () {
  return request({
    url: '/scp/scpHardwareBoxPlanWork/projectCombobox',
    method: 'get'
  })
}

// 查询计划执行信息
export function apiGetSelectPlanInfo () {
  return request({
    url: '/scp/scpHardwareBoxPlanWork/selectPlanInfo',
    method: 'get'
  })
}

// 分页查询五金箱计划工作台
export function apiHardwareBoxPlanWorkPage (data) {
  return request({
    url: '/scp/scpHardwareBoxPlanWork/page',
    method: 'post',
    data: data
  })
}

// 批量下单
export function apiBatchPlaceOrder (data) {
  return request({
    url: '/scp/scpHardwareBoxPlanWork/batchPlaceOrder',
    method: 'post',
    data: data
  })
}

// 导出五金箱计划工作台
export function apiHardwareBoxPlanWorkExport (data) {
  return request({
    url: '/scp/scpHardwareBoxPlanWork/export',
    method: 'post',
    data: data
  })
}

// 供需计算
export function apiCalculationSupplyDemand (data) {
  return request({
    url: '/scp/scpHardwareBoxPlanWork/calculationSupplyDemand',
    method: 'post',
    data: data
  })
}
